import "./App.css";
import Main from "./throwbreak420/Main";

function App() {
  return <Main />;
}

export default App;
